<template>
  <!--
    Tabs:
      b-tabs:class ==
        .tabs

    Tabs Nav:
      b-tabs:nav-wrapper-class ==
        .tabs > div
      b-tabs:nav-class ==
        .tabs > div > .nav
      b-tab:title-item-class ==
        .tabs > div > .nav > .nav-item
      b-tab:title-link-class ==
        .tabs > div > .nav > .nav-item > .nav-link
      b-tabs:active-nav-item-class
        .tabs > div > .nav > .nav-item > .nav-link.active
  -->

  <!-- LAZY LOADING IS DAMN IMPORTANT -->
  <b-tabs
      v-model="activeTabIndex"
      active-nav-item-class=""
      active-tab-class="d-flex flex-column"
      class="d-flex flex-grow-1 h-0 flex-column"
      content-class="d-flex mt-3 flex-grow-1 h-0 flex-column rounded-tl-1 bg-theme-1"
      nav-class="m-0 flex-grow-1 w-0 flex-nowrap gmb-feature-tabs-nav"
      nav-wrapper-class="d-flex border-bottom-0 p-0 bg-transparent"
      pills
      @input="(newTabIndex) => $emit('activated-tab-changed', newTabIndex)"
  >

    <slot name="tabList"/>

    <template #tabs-end>
      <!--b-nav-item role="presentation" @click.prevent="newTab" href="#"><b>+</b></b-nav-item-->
      <div class="gmb-other-brand-logo">

        <img v-if="mustDisplayLogos && activatedEntity.entityType == 'organization' && activatedEntity.entityObj.brand_logo_url !== ''"
           :title="activatedEntity.entityObj.brand_name" :src="activatedEntity.entityObj.brand_logo_url"
             >

        <img v-if="mustDisplayLogos && brandingInformation.brand_logo_url"
           :title="brandingInformation.brand_name" :src="brandingInformation.brand_logo_url"
             >

      </div>

    </template>

  </b-tabs>
</template>

<script>
export default {
  name: "GmbTabs",

  components: {},

  props: {
    brandingInformation: Object,
    activatedEntity: Object,
  },

  data() {
    return {
      activeTabIndex: 0,
    };
  },

  computed: {
    mustDisplayLogos() {
      return (this.brandingInformation && this.brandingInformation.brand_integration != 'NO_BRANDING');
    }
  },

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {
    activateTab(newTabIndex) {
      this.activeTabIndex = newTabIndex;
    },
  },
};
</script>

<style lang="scss">

.gmb-other-brand-logo {
    height: 40px;
    margin-left: auto;
    margin-right: 1rem
}

.gmb-other-brand-logo img {
  margin: 0 1rem;

}

</style>
